@if (arbetsorder?.id === arbetsorderid) {
  <div class="container planera-detail-height">
    <div class="row">
      <div class="col-12 p-2 mb-3">
        <rask-arbetsorder-header
          [arbetsorder]="arbetsorder"
        [isDetailedView]="true"></rask-arbetsorder-header>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <rask-arbetsorder-alert [arbetsorder]="arbetsorder">
        </rask-arbetsorder-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        @if (!arbetsorder.isLeveransvirke && !arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
          <rask-arbetsorder-periodsatt-period
            [arbetsorder]="arbetsorder">
          </rask-arbetsorder-periodsatt-period>
        }
        @if (!!arbetsorder.isLeveransvirke || !!arbetsorder.isTerminalImport || !!arbetsorder.isExternArbetsorder) {
          <rask-arbetsorder-produktionsdatum
            [arbetsorder]="arbetsorder"
            [onProduktionsdatumUpdated]="onProduktionsdatumUpdated">
          </rask-arbetsorder-produktionsdatum>
        }
      </div>
    </div>
    <div>
      <rask-toggle-panel label="Information" id="planera-limpa-information"
        [defaultExpanded]="defaultExpandInformation">
        <ng-container>
          <rask-arbetsorder-information
            [updatedAtgardBarighet]="updatedAtgardBarighet"
            [produktgrupper]="basdata.produktgrupper">
          </rask-arbetsorder-information>
        </ng-container>
      </rask-toggle-panel>
    </div>

    <div>
        <rask-toggle-panel
            label="Restriktioner" [defaultExpanded]="false" [icon]="restriktionerStatusIcon"
            [badgeText]="antalRestriktioner > 0 ? antalRestriktioner.toString() : null">
            <br />
            <ng-container>
                <rask-arbetsorder-restriktioner [arbetsorder]="arbetsorder"></rask-arbetsorder-restriktioner>
            </ng-container>
        </rask-toggle-panel>
    </div>
    <div>
      @if (!arbetsorder.isLeveransvirke && !arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
        <rask-toggle-panel
          label="Maskinlag" [defaultExpanded]="false" icon="ri ri-fw ri-maskinlag">
          <ng-container>
            <rask-arbetsorder-maskinlag></rask-arbetsorder-maskinlag>
          </ng-container>
        </rask-toggle-panel>
      }
    </div>
    <div>
      @if (arbetsorder.isTerminalImport || arbetsorder.isExternArbetsorder) {
        <rask-toggle-panel
          label="Handelssortiment" [defaultExpanded]="false" icon="fas fa-tree">
          <ng-container>
            <rask-arbetsorder-handelssortimentsval></rask-arbetsorder-handelssortimentsval>
          </ng-container>
        </rask-toggle-panel>
      }
      @if (!arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
        <rask-toggle-panel label="Produkt"
          [defaultExpanded]="false" icon="fas fa-tree">
          <ng-container>
            <rask-arbetsorder-produktval></rask-arbetsorder-produktval>
          </ng-container>
        </rask-toggle-panel>
      }
    </div>
    <div>
      <rask-toggle-panel label="Destinering" [defaultExpanded]="false" icon="fas fa-fw fa-industry"
        [showLoader]="destineringsalternativAsyncProgress">
        <ng-container>
          <rask-arbetsorder-destineringsalternativ
            (commandOutput)="onAddDestineraCommand($event)"
            (validationOutput)="onDestineraValidate($event)"
            (asyncProgressOutput)="onDestineringsalternativLoading($event)">
          </rask-arbetsorder-destineringsalternativ>
        </ng-container>
      </rask-toggle-panel>
    </div>
    <div>
      @if (!arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
        <rask-toggle-panel
          label="Drivningspunkter" [defaultExpanded]="false" icon="fas fa-fw fa-map-marker-alt">
          <ng-container>
            <rask-arbetsorder-drivningspunkter
              [hamtadrivningspunkter]="onHamtaDrivningspunkter"
              (updated)="drivningspunkterStatusChanged($event)">
            </rask-arbetsorder-drivningspunkter>
          </ng-container>
        </rask-toggle-panel>
      }
    </div>
    <div>
      <rask-toggle-panel label="Händelselogg" [defaultExpanded]="false" [badgeText]="sumOlastaHandelser"
        (onToggle)="onToggleHandelselogg($event)">
        <ng-container>
          <rask-verksamhetshandelse-logg
            [handelserReadDone]="handelserReadDone"
            [criteria]="verksamhetsHandelseRequest"
            (sumOlastaHandelser)="setSumOlastaHandelser($event)"
            [rows]="2"
            [olastaHandelserShowPlusSignAt]="9">
          </rask-verksamhetshandelse-logg>
        </ng-container>
      </rask-toggle-panel>
    </div>
    <div>
      @if (!arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
        <rask-toggle-panel
          label="Hantera åtgärder" [defaultExpanded]="false">
          <ng-container>
            <rask-arbetsorder-atgard></rask-arbetsorder-atgard>
          </ng-container>
        </rask-toggle-panel>
      }
    </div>
    <div class="row mt-3">
      <div class="col-9">
        @if (arbetsorder && arbetsorder.viol3) {
          <rask-arbetsorder-viol3-button
            [arbetsorder]="arbetsorder"
            [isFormDirty]="isDirty">
          </rask-arbetsorder-viol3-button>
        }
      </div>
      <div class="col-3">
        <rask-arbetsorder-violversion-selector class="col-4"[arbetsorder]="arbetsorder"></rask-arbetsorder-violversion-selector>
      </div>
    </div>
    <div class="footer-compensation"></div>
  </div>
}